import types from "./types";

const initialState = {
  newsLetterSubscriptionResponse: {},
  aboutUs: {},
  contactUs: {},
  helpUs: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.NEWSLETTER_RESPONSE:
      return {
        ...state,
        newsLetterSubscriptionResponse: action.payload,
      };
    case types.ABOUT_US_RESPONSE:
      return {
        ...state,
        aboutUs: action.payload,
      };
    case types.ABOUT_US_RESPONSE_CLEAR:
      return {
        ...state,
        aboutUs: {},
      };
    case types.CONTACT_US_RESPONSE:
      return {
        ...state,
        contactUs: action.payload,
      };
    case types.CONTACT_US_RESPONSE_CLEAR:
      return {
        ...state,
        contactUs: {},
      };
    case types.HELP_US_RESPONSE:
      return {
        ...state,
        helpUs: action.payload,
      };
    case types.HELP_US_RESPONSE_CLEAR:
      return {
        ...state,
        helpUs: {},
      };
    default:
      return state;
  }
};
